interface SearchInputProps {
    value: string;
    handleSubmit: () => void;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function SearchInput({ value = "", handleSubmit, handleChange }: SearchInputProps) {
    return (
        <>
            <form
                className="relative w-full h-[48px] rounded-[8px] border border-[#FF5E00] bg-white overflow-hidden"
                onSubmit={e => {
                    e.preventDefault();
                    handleSubmit();
                }}
            >
                <input type={`text`} className="w-full h-full p-[0_44px_0_12px]" value={value} onChange={handleChange} />
                <button
                    type="submit"
                    className="font-0 -indent-[9999px] absolute w-[44px] h-full right-0 top-0 bg-ic_search bg-no-repeat bg-center"
                >
                    검색하기 버튼
                </button>
            </form>
        </>
    );
}
